<script setup lang="ts">
import { RouterLink } from 'vue-router'

withDefaults(defineProps<{ title: string; crumb?: string; kicker?: string; kickerStrong?: string }>(), {
  crumb: '', kicker: '', kickerStrong: '',
})
</script>

<template>
  <section
    class="common-banner"
    :style="{ backgroundImage: 'url(/images/game-bg.png)' }"
  >
    <div class="container">
      <div
        v-reveal
        class="common-banner__content"
      >
        <span
          v-if="kicker || kickerStrong"
          class="sub-title text-xl"
        ><strong v-if="kickerStrong">{{ kickerStrong }}</strong>{{ kicker }}</span>
        <h2 class="fw-6 mt-16">
          {{ title }}
        </h2>
        <nav
          aria-label="breadcrumb"
          class="mt-16"
        >
          <ol class="breadcrumb">
            <li>
              <RouterLink to="/">
                Home
              </RouterLink>
            </li>
            <li
              class="active"
              aria-current="page"
            >
              {{ crumb || title }}
            </li>
          </ol>
        </nav>
        <div class="common-banner__meta mt-24">
          <slot />
        </div>
      </div>
    </div>
    <div class="stars">
      <img
        src="/images/stars.png"
        alt=""
      >
    </div>
    <div class="shape">
      <img
        src="/images/shape.png"
        alt=""
      >
    </div>
  </section>
</template>
